module.exports = __webpack_public_path__ + "hometogo-logo.png?a7ed344c305a21c2aaaba1fd13eb5a61";